package feature.customer.viewModel

import com.darkrockstudios.libraries.mpfilepicker.MPFile
import common.constants.KeyConstant
import common.constants.UserDefaults
import feature.app.AppViewModel
import feature.auth.handler.AuthHandler
import feature.business.handler.BusinessHandler
import feature.customer.handler.CustomerHandler
import feature.customer.model.Customer
import feature.customer.network.CreateCustomerRequest
import feature.customer.network.CustomerNetwork
import feature.customer.network.FetchCustomerRequest
import feature.customer.network.FindCustomerRequest
import feature.customer.network.UpdateCustomerRequest
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json

class CustomerViewModel : AppViewModel() {

    val json = Json {
        ignoreUnknownKeys = true
    }

    val repository = CustomerHandler.shared().repository

    val allCustomer: StateFlow<ArrayList<Customer>>
        get() = repository.allCustomer

    val customer: StateFlow<Customer?>
        get() = repository.customerState
    val editCustomer: StateFlow<Customer?>
        get() = repository.editCustomer
    val searchQuery: StateFlow<String>
        get() = repository.searchQuery

    fun setUserImage(image: MPFile<Any>, context: Any) {
//        CoroutineScope(Job() + Dispatchers.Default).launch {
//            val fullImage = image.readAsBytes()?.let {
//                ImageWithData(
//                    id = uuid(),
//                    file = image,
//                    data = it,
//                    imageBitmap = it.toImageBitmap(context, image).downscale()
//                )
//            }
//            image.value = fullImage
//        }
    }

    override fun changeSearchQuery(value: String) {
        CoroutineScope(Job() + Dispatchers.Default).launch {
            repository.searchQueryState.emit(value)
        }
        performSearch(value)
    }

    override fun performSearch(value: String) {
        val searchQueryText = value.lowercase()
        CoroutineScope(Job() + Dispatchers.Default).launch {
            val filteredResult = repository.allUnFilteredCustomer.value.filter { item ->
                item.Name?.lowercase()
                    ?.contains(searchQueryText) == true || item.MobileNumber?.lowercase()
                    ?.contains(searchQueryText) == true || item.EmailID?.lowercase()?.contains(
                    searchQueryText
                ) == true || item.barcode?.contains(value) == true
            } as ArrayList<Customer>
            repository.allCustomerState.emit(filteredResult)
        }
    }

    fun editCustomer(value: Customer?) {
        repository.setEditCustomer(value)
    }

    fun editCustomerName(value: String) {
        repository.editCustomer.value?.Name = value
    }

    fun editCustomerMobile(value: String) {
        repository.editCustomer.value?.MobileNumber = value
    }

    fun editCustomerDialCode(value: String) {
        repository.editCustomer.value?.DialCode = value
    }

    fun editCustomerEmail(value: String) {
        repository.editCustomer.value?.EmailID = value
    }

    fun editCustomerBarcode(value: String) {
        repository.editCustomer.value?.barcode = value
    }


    fun fetchAllCustomer() {
        startLoading()
        val request = FetchCustomerRequest(
            BusinessHandler.shared().repository.business.value.Id,
            null//repository.lastSyncDate.value
        )
        CoroutineScope(Job() + Dispatchers.Default).launch {
            CustomerNetwork().retrieveCustomer(request) {
                stopLoading()
                if (it?.lastSyncDate?.isNotBlank() == true) {
                    CoroutineScope(Job() + Dispatchers.Default).launch {
                        repository.lastSyncDateState.emit(it.lastSyncDate)
                    }
                }
                if (it?.payload?.isNotEmpty() == true) {
                    CoroutineScope(Job() + Dispatchers.Default).launch {
                        val allNewRecords =
                            (it.payload + repository.allCustomer.value) as ArrayList<Customer>
                        repository.allCustomerState.emit(it.payload)
                        repository.allUnFilteredCustomerState.emit(it.payload)
                    }
                }
            }
        }
    }

    fun createNewCustomer(
        name: String,
        dialCode: String,
        mobile: String,
        email: String,
        barcode: String,
        callBack: (Boolean) -> Unit
    ) {
        val request = CreateCustomerRequest(
            AuthHandler.shared().repository.authUser.value.id,
            BusinessHandler.shared().repository.business.value.Id,
            name,
            dialCode,
            mobile,
            email,
            barcode,
            AuthHandler.shared().deviceId
        )
        startLoading()
        CoroutineScope(Job() + Dispatchers.Default).launch {
            CustomerNetwork().createCustomer(request) {
                stopLoading()
                if (!it?.payload?.Id.isNullOrEmpty()) {
                    callBack(true)
                    CoroutineScope(Job() + Dispatchers.Default).launch {
                        CustomerHandler.shared().repository.customerState.emit(it!!.payload!!)
                    }
                } else {
                    callBack(false)
                }
            }
        }
    }

    fun updateCustomer(
        callBack: (Boolean) -> Unit
    ) {
        val request = editCustomer.value?.let {
            UpdateCustomerRequest(
                it.Id,
                AuthHandler.shared().repository.authUser.value.id,
                BusinessHandler.shared().repository.business.value.Id,
                editCustomer.value?.Name ?: "",
                editCustomer.value?.DialCode ?: "",
                editCustomer.value?.MobileNumber ?: "",
                editCustomer.value?.EmailID ?: "",
                editCustomer.value?.barcode ?: "",
                AuthHandler.shared().deviceId
            )
        }
        request?.let {
            startLoading()
            CoroutineScope(Job() + Dispatchers.Default).launch {
                CustomerNetwork().updateCustomer(it) { response ->
                    stopLoading()
                    if (!response?.payload?.Id.isNullOrEmpty()) {
                        callBack(true)
                        CoroutineScope(Job() + Dispatchers.Default).launch {
                            CustomerHandler.shared().repository.customerState.emit(response!!.payload!!)
//                            repository.lastSyncDateState.emit(null)
                        }
                    } else {
                        callBack(false)
                    }
                }
            }
        }
    }
//
//    fun updateCustomer(customer: Customer) {
//        val user = FriendlyUser()
//        var request = JSONObject()
//        request.put(KeyConstant.userId, user._id)
//        request.put(KeyConstant.businessID, BusinessHandler.shared().repository.business.value?.Id)
//        request.put(KeyConstant.name, customer.Name)
//        request.put(KeyConstant.mobileNumber, customer.MobileNumber)
//        request.put(KeyConstant.emailId, customer.EmailID)
//        request.put(KeyConstant.barcode, customer.Barcode)
//        request.put(KeyConstant.deviceId, AuthHandler.shared().deviceId)
//        SocketService.shared().send(SocketEvent.UPDATE_CUSTOMER, request)
//    }
//
//    fun insert(customer: Customer) {
//        CoroutineScope(Job() + Dispatchers.IO).launch {
//            DatabaseHandler.shared().database.customerDao()
//                .insert(customer)
//        }
//    }
//
//    fun getInvoiceCount(id: String, completion: (count: Int) -> Unit) {
//        if (!BusinessHandler.shared().repository.business.value?.Id.isNullOrEmpty()) {
//            scope.launch {
//                val totalInvoiceCount =
//                    DatabaseHandler.shared().database.customerDao().getInvoiceCount(id)
//                if (totalInvoiceCount != null) {
//                    completion(totalInvoiceCount)
//                }
//            }
//        }
//    }
//
//    fun getTotalInvoiceValue(id: String, completion: (count: Float) -> Unit) {
//        if (!BusinessHandler.shared().repository.business.value?.Id.isNullOrEmpty()) {
//            scope.launch {
//                val totalInvoiceValue =
//                    DatabaseHandler.shared().database.customerDao().getTotalInvoiceValue(id)
//                if (totalInvoiceValue != null) {
//                    completion(totalInvoiceValue)
//                }
//            }
//        }
//    }

    fun findCustomerByMobile(mobile: String, dialCode: String) {
        val request = FindCustomerRequest(
            "15143667976",
            dialCode,
            BusinessHandler.shared().repository.business.value.Id
        )
        CoroutineScope(Job() + Dispatchers.Default).launch {
            CustomerNetwork().findCustomerByMobile(request) {
                if (!it?.payload?.Id.isNullOrEmpty()) {
                    CoroutineScope(Job() + Dispatchers.Default).launch {
                        CustomerHandler.shared().repository.customerState.emit(it!!.payload!!)
                    }
                }
            }
        }
    }

    fun loadMembership(mobile: String, dialCode: String) {
        val membershipDetails = UserDefaults.retrieveMembership(KeyConstant.membershipDetails)
        if (membershipDetails.isNotEmpty()) {
            val membership: Customer = json.decodeFromString(membershipDetails)
            CoroutineScope(Job() + Dispatchers.Default).launch {
                CustomerHandler.shared().repository.customerState.emit(membership)
            }
        } else {
            val request = FindCustomerRequest(
                mobile,
                dialCode,
                BusinessHandler.shared().repository.business.value.Id
            )
            CoroutineScope(Job() + Dispatchers.Default).launch {
                CustomerNetwork().findCustomerByMobile(request) {
                    if (!it?.payload?.Id.isNullOrEmpty()) {
                        CoroutineScope(Job() + Dispatchers.Default).launch {
                            CustomerHandler.shared().repository.customerState.emit(it!!.payload!!)
                            UserDefaults.store(
                                KeyConstant.membershipDetails,
                                Json.encodeToString(it.payload!!)
                            )
                        }
                    }
                }
            }
        }
    }
}